import {Component, Input, OnInit} from '@angular/core';
import {ITrainingType} from '../../../message-models/training-record-type.interface';
import {TrainingType} from '../../../message-models/training-record-type.class';
import {IDocumentType} from '../../../message-models/document-type.interface';
import {EcaDocumentType} from '../../../message-models/eca-document-type.class';

@Component({
  selector: 'app-document-type-editor',
  templateUrl: './document-type-editor.component.html',
  styleUrls: ['./document-type-editor.component.scss']
})
export class DocumentTypeEditorComponent implements OnInit {
  @Input() documentType: IDocumentType = new EcaDocumentType();
  @Input() editingType: boolean = false;
  @Input() saveAttempted: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }
}
